// removed by extract-text-webpack-plugin
module.exports = {"card":"hzwl5yrePlbjXMv41w_Iy","date":"_3R44O8gcadn9UVE4uR7Agw","text":"Ws3US35LsmrdKKHlLRXfb"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Report/Report.scss
// module id = 880
// module chunks = 0